import { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux";
import { setUser } from "../redux/slices/userSlice";
import { setQueries } from "../redux/slices/fetchStatusSlice";
import MeterianSDK from "../classes/MeterianSDK";

const useAuthenticateUserOnComponentMount = () => {
    const user = useSelector((state) => state.auth.user)
    const dispatch = useDispatch()

    const successAuth = async (user) => {
        window.meterian = new MeterianSDK()
        const teams = await window.meterian.teams.all(user.account)
        const mappedUser = {...user, teams: teams.map(({uuid, name}) => {
            return { uuid, name }
        })}
        dispatch(setUser(mappedUser))
        dispatch(setQueries({}))
        if (window.auth.lock) window.auth.lock.hide();
    }
    
    const failAuth = () => {
        dispatch(setUser({}))
        setTimeout(() => {
            window.auth.lock.showLock();
        }, 500)
    }

    useEffect(() => {
        window.auth.initializeAuth(null, successAuth, failAuth)
    }, []);
    return {user}
}


export default useAuthenticateUserOnComponentMount